/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminDivision
 */
export interface InputAdminDivision {
    /**
     * 
     * @type {number}
     * @memberof InputAdminDivision
     */
    brigadeId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminDivision
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminDivision
     */
    zone?: number;
}

/**
 * Check if a given object implements the InputAdminDivision interface.
 */
export function instanceOfInputAdminDivision(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputAdminDivisionFromJSON(json: any): InputAdminDivision {
    return InputAdminDivisionFromJSONTyped(json, false);
}

export function InputAdminDivisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminDivision {
    if (json == null) {
        return json;
    }
    return {
        
        'brigadeId': json['brigadeId'] == null ? undefined : json['brigadeId'],
        'name': json['name'],
        'zone': json['zone'] == null ? undefined : json['zone'],
    };
}

export function InputAdminDivisionToJSON(value?: InputAdminDivision | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'brigadeId': value['brigadeId'],
        'name': value['name'],
        'zone': value['zone'],
    };
}

